import { AppConfig, Environment } from '@/model/entities/app-config.interface'
import { useConfigContext, getConfig as getConfigFromProvider } from '@/context/providers/ConfigProvider'

export const useConfig = () => {
  return useConfigContext()
}

export const getEnv = (): Environment | null => {
  return getConfigFromProvider()?.Environment ?? null
}

export const getConfig = (): AppConfig | null => {
  return getConfigFromProvider()
}
